import styled from 'styled-components';
import { DEFAULT_COLORS } from 'components/core/colors';

export const AddressWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  line-height: 1.4;
`;

export const AccountName = styled.div`
  font-weight: 500;
  color: ${DEFAULT_COLORS.ink.darkest};
  letter-spacing: -0.01em;
`;

export const AccountAddress = styled.div`
  font-weight: 400;
  color: ${DEFAULT_COLORS.ink.lighter};
`;
